<div>
  <!--<app-sidebar></app-sidebar>-->
  <!--<div *ngIf="data.loadingApp" style="position:fixed; background-color: rgba(20,20,20,0.7); height: 100vh; width: 100%; z-index: 20; display:block;">-->
    <!--&lt;!&ndash;<mat-progress-spinner style="height: 100%; margin:auto;" color="accent" mode="indeterminate"></mat-progress-spinner>&ndash;&gt;-->
    <!--<div class="svg-wrapper">-->
      <!--<div class="earth-svg"></div>-->
      <!--<div class="earth-satellite"></div>-->
    <!--</div>-->
  <!--</div>-->
  <div *ngIf="data.loadingApp || data.lazyLoadingRoute" style="position:fixed; background-color: #FFF; height: 100vh; width: 100%; z-index: 200; display:block;">
    <!-- loading layout replaced by app after startupp -->
    <div class="app-loading">
      <img class="logo" src="assets/images/logo.svg" style="width: 80px; height: 80px;">
      <svg class="spinner" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="1" stroke-miterlimit="10"/>
      </svg>
    </div>
    <div class="loading-text" *ngIf="loadingPageIndex === null">
      {{data.userConfirmed ? 'Collecting your data...' : 'Connecting to the server...'}}
    </div>
    <div class="loading-text" *ngIf="loadingPageIndex !== null">
      {{data.userConfirmed ? content.generalPage.data[loadingPageIndex]?.title : content.generalPage.data[loadingPageIndex]?.description}}
    </div>
  </div>
  <!--<div *ngIf="data.loadingApp === false && data.userConfirmed === true && deviceNotOptimized === true" style="position:fixed; line-height: 50px; background-color: #2e425a; color: white; font-family: Montserrat; height: 50px; width: 100vw; z-index: 20; display:block; text-align: center;">-->
    <!--Not optimized for mobile, please use PC-->
  <!--</div>-->
  <div [@routerTransition]="page.activatedRouteData.state">
    <router-outlet #page="outlet"></router-outlet>
  </div>
  <app-alert-dev-env></app-alert-dev-env>
</div>
